/* eslint-disable react/display-name */
import React from 'react';
import {
  node,
} from 'prop-types';

import './AnchorTabs.scss';

const TabPanel = React.forwardRef((props, ref) => (
  <div ref={ref}>
    {props.children}
  </div>
));

TabPanel.propTypes = {
  children: node.isRequired,
};

export default TabPanel;
